import React from 'react';
import ChatBot from './ChatBot';
import { useChatBot } from '@root/context/ChatBotContext';

const ChatBotWrapper: React.FC = () => {
  const { initialMessage, closeChatBot } = useChatBot();

  return (
    <ChatBot
      initialMessage={initialMessage || undefined}
      onOpenChange={(open) => {
        if (!open) {
          closeChatBot();
        }
      }}
    />
  );
};

export default ChatBotWrapper;
